import { makeStyles } from "@material-ui/core/styles";
import { blue900, lightGray } from "../../../../components/common/PL/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  time: {
    color: blue900,
    fontWeight: 600,
    flexShrink: 0,
    minWidth: 48,
  },
  avatar: {
    width: 36,
    height: 36,
    fontSize: "0.85rem",
    backgroundColor: "#E5E7EB",
    color: "#4B5563",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  name: {
    color: blue900,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  description: {
    fontSize: "0.85rem",
    color: lightGray,
    lineHeight: 1.3,
  },
  badge: {
    marginLeft: "auto",
    flexShrink: 0,
  },
}));


export default useStyles;
